import { render } from "./BursaryAwardsdashboard.vue?vue&type=template&id=346050ba&scoped=true"
import script from "./BursaryAwardsdashboard.vue?vue&type=script&lang=js"
export * from "./BursaryAwardsdashboard.vue?vue&type=script&lang=js"

import "./BursaryAwardsdashboard.vue?vue&type=style&index=0&id=346050ba&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346050ba"]])

export default __exports__